// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__KLhVx","tab":"ProcedureTabs_tab__3ufMa"};